import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, Mail } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden"
      style={{ background: "var(--color-dark)", color: "var(--color-bg)" }}
    >
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <h3 className="text-3xl sm:text-4xl mb-3 font-[\'Playfair_Display\']">
              La Caravelle
            </h3>
            <p className="text-sm leading-relaxed opacity-80 max-w-md">
              {t.common.footerTagline}
            </p>
            <a
              href="tel:0468325017"
              data-testid="footer-cta-phone"
              className="inline-flex mt-6 btn-pill btn-light text-sm"
            >
              <Phone size={14} /> {t.common.reserveTable}
            </a>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] opacity-60 mb-4">
              {t.common.contact}
            </p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-1 flex-shrink-0 opacity-70" />
                <span>Prom. du Front de Mer, 11100 Narbonne</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={15} className="mt-1 flex-shrink-0 opacity-70" />
                <a href="tel:0468325017" data-testid="footer-phone" className="hover:underline">
                  04 68 32 50 17
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-1 flex-shrink-0 opacity-70" />
                <a
                  href="mailto:lacaravellenarbonne@gmail.com"
                  data-testid="footer-email"
                  className="hover:underline break-all"
                >
                  lacaravellenarbonne@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] opacity-60 mb-4">
              {t.common.hours}
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start gap-3">
                <Clock size={15} className="mt-1 flex-shrink-0 opacity-70" />
                <div>
                  <p>{t.common.everyday}</p>
                  <p className="opacity-70">9h00 – 00h00</p>
                </div>
              </li>
            </ul>

            <p className="text-[11px] uppercase tracking-[0.25em] opacity-60 mt-8 mb-3">
              {t.common.cardsLabel}
            </p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/carte-restaurant" className="opacity-80 hover:opacity-100 hover:underline">
                  {t.nav.restaurant}
                </Link>
              </li>
              <li>
                <Link to="/carte-petit-dejeuner" className="opacity-80 hover:opacity-100 hover:underline">
                  {t.nav.petitDejeuner}
                </Link>
              </li>
              <li>
                <Link to="/carte-gourmande" className="opacity-80 hover:opacity-100 hover:underline">
                  {t.nav.gourmande}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs opacity-60">
          <p>© {new Date().getFullYear()} La Caravelle — Narbonne</p>
          <p className="font-[\'Playfair_Display\'] italic">{t.common.footerQuote}</p>
        </div>
      </div>
    </footer>
  );
};
